import React from "react";
import { ActionList } from "@primer/react";

interface ViewAllLinkProps {
  href: string;
  label: string;
}

export const ViewAllLink: React.FC<ViewAllLinkProps> = ({ href, label }) => (
  <ActionList.LinkItem href={href} sx={{ textAlign: "center" }}>
    {label}
  </ActionList.LinkItem>
);
